import styled from "styled-components";

export const Label = styled.span`
  &:after {
    content: ${({ required = false }) => (required ? '"*"' : "normal")};
    color: rgb(255, 68, 0);
  }
`;
